import { SERVICE } from './constants'

export const SET_TYPES = `${SERVICE}/SET_TYPES`
export const CLEAR_TYPES = `${SERVICE}/CLEAR_TYPES`
